import * as React from 'react';

import { cn } from '../../lib/cn';

const VALUE_TONE = {
  warning: 'text-dusq-warning',
  negative: 'text-dusq-negative',
  neutral: 'text-dusq-emphasis-high',
};

/**
 * The headline counters at the top of a dashboard: a big number, a quiet label and,
 * when a page has one, a 12px line of context under it (`meta`).
 */
export const StatCard = React.forwardRef(
  ({ className, value, label, meta, tone = 'neutral', ...props }, ref) => (
    <div
      ref={ref}
      className={cn(
        'flex flex-1 flex-col gap-3 rounded-[12px] bg-dusq-grey950 px-6 py-3',
        className
      )}
      {...props}
    >
      <span
        className={cn(
          'font-display text-[51px] font-semibold leading-[normal]',
          VALUE_TONE[tone] || VALUE_TONE.neutral
        )}
      >
        {value}
      </span>
      <span className="font-dusq text-[14px] tracking-[0.28px] text-dusq-emphasis-disabled">
        {label}
      </span>
      {meta && (
        <span className="-mt-1.5 font-dusq text-[12px] leading-[1.35] text-dusq-grey400">
          {meta}
        </span>
      )}
    </div>
  )
);
StatCard.displayName = 'StatCard';
